import {API_KEY} from "./my_key.js";
import {verse_selected} from "./verse-selected.js";



export async function verse01(){var activities_verse_selected = document.getElementById("verse_type");
  activities_verse_selected.addEventListener("change", function() {
    var x = activities_verse_selected.selectedIndex;

    verse_selected(activities_verse_selected.options[activities_verse_selected.selectedIndex].id,activities_verse_selected.options[activities_verse_selected.selectedIndex].value,document.getElementById("bible_type").options[document.getElementById("bible_type").selectedIndex].value);

});

   }

export async function verse(chapter,version,abbr){
      var jsonArray = [];
      const bibleVerseList = document.querySelector(`#verse-list`);
      const chapterText = document.querySelector(`#chapter-text`);
      const bibleVersionID = version;
      const bibleChapterID =chapter;
      const abbreviation = abbr;
      let verseHTML = ``;


 document.getElementById("verse_type").innerText = null;
   await getVerses(bibleVersionID, bibleChapterID).then((verseList) => {
        console.log(verseList);
        for (let verse of verseList) {
          var option = document.createElement("option");
           const verseNumber = getVerseNumber(verse.id);
            option.id = verse.id;
            option.value =bibleVersionID;
            option.text =verseNumber;

  var jsonObject = {
  "id": verse.id,
  "value":bibleVersionID,
  "text": verseNumber
};

jsonArray.push(jsonObject);
           }

      });

     // getChapterText(bibleVersionID,bibleChapterID).then((content) => {
       
      //});
      return jsonArray;
}
      /**
       * Gets verses from API.Bible
       * @param {string} bibleVersionID to get verses from
       * @param {string} bibleChapterID to get verses from
       * @returns {Promise} containing list of verses from selected book
       */
      function getVerses(bibleVersionID, bibleChapterID) {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = false;

          xhr.addEventListener(`readystatechange`, function() {
            if (this.readyState === this.DONE) {
              const {data} = JSON.parse(this.responseText);
              const verses = data.map( ({id}) => { return {id};} );

              resolve(verses);
            }
          });

          xhr.open(`GET`, `https://api.scripture.api.bible/v1/bibles/${bibleVersionID}/chapters/${bibleChapterID}/verses`);
          xhr.setRequestHeader(`api-key`, API_KEY);

          xhr.onerror = () => reject(xhr.statusText);

          xhr.send();
        });
      }

      /**
       * Gets chapter text from API.Bible
       * @param {string} bibleChapterID to get chapter text from
       * @returns {Promise} containing text from selected chapter
       */
      function getChapterText(bibleVersionID,bibleChapterID) {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.withCredentials = false;

          xhr.addEventListener(`readystatechange`, function() {
            if (this.readyState === this.DONE) {
              const {data, meta} = JSON.parse(this.responseText);

              //_BAPI.t(meta.fumsId);
              resolve(data.content);
            }
          });

          xhr.open(`GET`, `https://api.scripture.api.bible/v1/bibles/${bibleVersionID}/chapters/${bibleChapterID}`);
          xhr.setRequestHeader(`api-key`, API_KEY);

          xhr.onerror = () => reject(xhr.statusText);

          xhr.send();
        });
      }

      /**
       * Parses verse number from verseID
       * @param {string} verseID verse ID
       * @returns {string} verse number or numbers
       */
      function getVerseNumber(verseID) {
        let verseNumber;
        if (verseID.includes(`-`)) {
          verseNumber = verseID.split(`-`).shift().split(`.`).pop() + `-` + verseID.split(`-`).pop().split(`.`).pop();
        } else {
          verseNumber = verseID.split(`.`).pop();
        }
        return verseNumber;
      }

      /**
       * Gets query parameter from URL based on name
       * @param {string} name of query parameter
       * @returns {string} value of query parameter
       */
      function getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, `\\$&`);
        const regex = new RegExp(`[?&]` + name + `(=([^&#]*)|&|#|$)`),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return ``;
        return decodeURIComponent(results[2].replace(/\+/g, ` `));
      }

      /**
       * Loads page for new search
       /* 
  This function is not yet being utalized much ... 2/3/2023
   function searchButton(){
      const searchInput = document.querySelector(`#search-input`);
      window.location.href = `./search.html?&version=${bibleVersionID}&abbr=${abbreviation}&query=${searchInput.value}`;
    }*/